export const APP_EXEPTION = "App exeption";
